import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { warmDiscoverFeed } from './mira/prefetch';

// Before React does anything. For a returning user the discover feed is the
// destination and its snapshot lives on a CDN we have already preconnected to
// in index.html, so there is no reason to wait for the router to resolve, the
// auth context to mount and an effect to fire before asking for it — that
// chain was costing every repeat visitor a fully serial fetch. No-ops for
// anyone without a token.
warmDiscoverFeed();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
